


































import {
  defineComponent,
  PropType,
  ref,
  watch,
  computed,
} from '@vue/composition-api'

import HLine from '@/components/atoms/HLine.vue'
import DateGroup from '@/components/organisms/h/item/date/DateGroup.vue'
import ItemHierarchyGroup from '@/components/organisms/h/item/hierarchy/ItemHierarchyGroup.vue'
import ExtractConditionLayout from '@/components/organisms/h/layout/ExtractConditionLayout.vue'
import {
  causalWeightConfExtractCondition,
  dateGroupExtractCondition,
  itemHierarchyGroupExtractCondition,
  itemHierarchyUseList,
  dateRange,
} from '@/types/entities'

export default defineComponent({
  components: {
    ExtractConditionLayout,
    DateGroup,
    ItemHierarchyGroup,
    HLine,
  },
  props: {
    defaultDateValue: {
      type: Array as PropType<string[]>,
      default: () => ['', ''],
    },
  },
  setup(props, context) {
    /*********************************
     * 表示する選択肢
     *********************************/
    const storeUseList = ref<itemHierarchyUseList>([['StoreShelve', 'Store']])
    const itemUseList = ref<itemHierarchyUseList>([['Shobunrui', 'Class', 'Category', 'Tanpin']])
    const causalUseList = ref<itemHierarchyUseList>([['Causal']])
    /*********************************
     * データ
     *********************************/
    const extractConditionOfDate = ref<dateGroupExtractCondition>({})
    const extractConditionOfStore = ref<itemHierarchyGroupExtractCondition>({})
    const extractConditionOfItem = ref<itemHierarchyGroupExtractCondition>({})
    const extractConditionOfCausal = ref<itemHierarchyGroupExtractCondition>({})

    /*********************************
     * emitデータの作成
     *********************************/
    // いずれかの抽出条件変更時の処理
    const whereValidData = ref<string[]>(props.defaultDateValue)
    const changeExtractCondition = () => {
      const base: causalWeightConfExtractCondition = {
        validData:
          extractConditionOfDate.value.dateRange ||
          (props.defaultDateValue as dateRange),
        storeShelve: extractConditionOfStore.value.storeShelve || [],
        storeShelveCount: extractConditionOfStore.value.storeShelveCount || 0,
        store: extractConditionOfStore.value.store || [],
        storeCount: extractConditionOfStore.value.storeCount || 0,
        shobunrui: extractConditionOfItem.value.shobunrui || [],
        shobunruiCount: extractConditionOfItem.value.shobunruiCount || 0,
        class: extractConditionOfItem.value.class || [],
        classCount: extractConditionOfItem.value.classCount || 0,
        category: extractConditionOfItem.value.category || [],
        categoryCount: extractConditionOfItem.value.categoryCount || 0,
        tanpin: extractConditionOfItem.value.tanpin || [],
        tanpinCount: extractConditionOfItem.value.tanpinCount || 0,
        causal: extractConditionOfCausal.value.causal || [],
        causalCount: extractConditionOfCausal.value.causalCount || 0,
      }

      let cond = { ...base }
      // console.log('changeExtractCondition', { cond })
      context.emit('change-extract-condition', cond)
      whereValidData.value =
        extractConditionOfDate.value.dateRange || props.defaultDateValue
    }

    /*********************************
     * 以下は各抽出条件変更時の処理
     *********************************/
    const changeExtractConditionOfDate = (
      params: dateGroupExtractCondition
    ) => {
      extractConditionOfDate.value = params
      changeExtractCondition()
    }
    const changeExtractConditionOfItem = (
      params: itemHierarchyGroupExtractCondition
    ) => {
      extractConditionOfItem.value = params
      changeExtractCondition()
    }
    const changeExtractConditionOfStore = (
      params: itemHierarchyGroupExtractCondition
    ) => {
      extractConditionOfStore.value = params
      changeExtractCondition()
    }
    const changeExtractConditionOfCausal = (
      params: itemHierarchyGroupExtractCondition
    ) => {
      extractConditionOfCausal.value = params
      changeExtractCondition()
    }

    const requiredItemInput = [
      '有効日：常に入力',
      '店舗エリア・店舗・小分類・単品・コーザルのいずれかを一つ以上選択',
    ]
    return {
      requiredItemInput,
      storeUseList,
      itemUseList,
      causalUseList,
      whereValidData,
      changeExtractConditionOfDate,
      changeExtractConditionOfItem,
      changeExtractConditionOfStore,
      changeExtractConditionOfCausal,
    }
  },
})
